import {Input} from "../Form/types";
import {createTextInput} from "../Form/Input";
import {__} from "@wordpress/i18n";

export const InputEmail = (el: HTMLElement|null) => {
    return el
        ? createTextInput( el as HTMLInputElement, ( input: Input, value: string ): void => {
            if ( ! /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()) ) {
                input.addError( __( 'Ungültige E-Mail Adresse.', 'dierck-group-company' ) );
            }
        } )
        : null;
}
